let cart = [];
let isDrawerOpen = false;

let drawerListeners = [];
let cartListeners = [];

const CART_VERSION = "v1";
const CART_TTL_DAYS = 7;

// Load cart from localStorage on startup
loadCartFromStorage();

export function addToCart(item) {
  const existing = cart.find(
    (i) => i.product_id === item.product_id && i.name === item.name
  );

  if (existing) {
    existing.quantity += item.quantity;
  } else {
    cart.push({
      product_id: item.product_id,
      name: item.name,
      quantity: item.quantity,
    });
  }

  saveCartToStorage();
  notifyCartListeners();
}

export function removeFromCart(product_id, name) {
  cart = cart.filter(
    (item) => item.product_id !== product_id || item.name !== name
  );
  saveCartToStorage();
  notifyCartListeners();
}

export function clearCart() {
  cart = [];
  saveCartToStorage();
  notifyCartListeners();
}

export function getCart() {
  return [...cart]; // return a copy
}

// Cart change listeners
export function onCartChange(listener) {
  cartListeners.push(listener);
  return () => {
    cartListeners = cartListeners.filter((fn) => fn !== listener);
  };
}

function notifyCartListeners() {
  cartListeners.forEach((fn) => fn(getCart()));
}

// Cart drawer state
export function openCartDrawer() {
  isDrawerOpen = true;
  notifyDrawerListeners();
}

export function closeCartDrawer() {
  isDrawerOpen = false;
  notifyDrawerListeners();
}

export function toggleCartDrawer() {
  isDrawerOpen = !isDrawerOpen;
  notifyDrawerListeners();
}

export function isCartDrawerOpen() {
  return isDrawerOpen;
}

// Drawer event listeners
export function onCartDrawerChange(listener) {
  drawerListeners.push(listener);
  return () => {
    drawerListeners = drawerListeners.filter((fn) => fn !== listener);
  };
}

function notifyDrawerListeners() {
  drawerListeners.forEach((fn) => fn(isDrawerOpen));
}

// --- Storage logic ---
function saveCartToStorage() {
  localStorage.setItem("cart", JSON.stringify(cart));
  localStorage.setItem("cart_version", CART_VERSION);
  localStorage.setItem("cart_saved_at", Date.now().toString());
}

function loadCartFromStorage() {
  try {
    const savedVersion = localStorage.getItem("cart_version");
    if (savedVersion !== CART_VERSION) {
      clearCartStorage();
      return;
    }

    const savedAt = parseInt(localStorage.getItem("cart_saved_at"), 10);
    const age = (Date.now() - savedAt) / (1000 * 60 * 60 * 24);
    if (isNaN(savedAt) || age > CART_TTL_DAYS) {
      clearCartStorage();
      return;
    }

    const savedCart = localStorage.getItem("cart");
    if (savedCart) {
      cart = JSON.parse(savedCart);
    }
  } catch (err) {
    console.error("Failed to load cart from storage", err);
    clearCartStorage();
  }
}

function clearCartStorage() {
  localStorage.removeItem("cart");
  localStorage.removeItem("cart_version");
  localStorage.removeItem("cart_saved_at");
  cart = [];
}
